import styled from "styled-components";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";
import { COLORS, FIELD_COLORS, TEXT_COLORS } from "../../constants/design/colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.one}px;
  padding: ${SPACING.two}px 10px;
  margin-bottom: ${SPACING.two}px;
  border-radius: ${BORDER_RADIUS.md}px;
  background: ${FIELD_COLORS.one};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.two}px;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${TEXT_COLORS.one};
  font-size: 13px;
  font-weight: 500;

  > svg {
    color: ${COLORS.highlight.one};
    flex-shrink: 0;
  }
`;

export const Sub = styled.div`
  color: ${TEXT_COLORS.two};
  font-size: 11px;
  line-height: 1.35;
`;

export const ErrorText = styled(Sub)`
  color: ${COLORS.negative.one};
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.two}px;
  margin-top: ${SPACING.one}px;

  > button {
    flex: 1 1 auto;
    min-height: 28px;
    font-size: 12px;
  }
`;
